import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_MYSTAGE_AGORA_TOKEN } from '@/graphql/mystageLessonToken';
import logger from '@/modules/Logger';

/**
 * Endpoint for Agora Token
 * This is used to request a new token from the backend for every retry UID
 */
export const GetAgoraTokenService = {
  msb: async (params) => {
    logger.debug(`[Agora Token] Fetch new agora token`, {
      operation: 'get:agora-token'
    }
    );

    try {
      const client = myStageApolloProvider.defaultClient;
      const { data } = await client.query({
        query: GET_MYSTAGE_AGORA_TOKEN,
        fetchPolicy: 'no-cache',
        variables: params
      });

      if (data?.agoraTokenNew) {
        return {
          token: data.agoraTokenNew.agora_token,
          uid: data.agoraTokenNew.uid
        };
      } else {
        logger.error(`[GetAgoraTokenService] Mystage Agora Token request failed: No token data found`, {
          operation: 'get:agora-token'
        });
      }
    } catch (error) {
      let message = error.message;
      logger.error(`[GetAgoraTokenService] Mystage Agora Token request failed: ${message}`, {
        operation: 'get:agora-token'
      });
    }
  }
};
